export default "__VITE_ASSET__BmB9jeBe__"